import axios from 'axios';

const baseUrl = '/uploads';

export default {
  getUploads() {
    return axios.get(`${baseUrl}/`);
  },
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${baseUrl}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
